import { SxProps } from '@mui/system';

export const content: SxProps = {
  display: '-webkit-box',
  // lineClamp: isMaxHeightContent ? 'unset' : '4',
  // WebkitLineClamp: isMaxHeightContent ? 'unset' : '4',
  WebkitBoxOrient: 'vertical',
  overflowY: 'hidden',
};
